import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
}));

const TimePicker = React.forwardRef((props, ref) => {
    const classes = useStyles();
    const { label, timeValue, handleChange } = props;
  
    return (
      <TextField
        id="time"
        label={label}
        type="time"
        defaultValue={timeValue}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          step: 300,
          ampm: "false"
        }}
        inputRef={ref}
        onChange={(e) => handleChange(e)}
      />
    );
  })

export default TimePicker;
